module.exports = __webpack_public_path__ + "static/media/bg_downgrade_suggestion_from_30_to_34.83836f4e.webp";